import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate'
import userStore from './userStore'
import commonStore from './commonStore'
import CryptoJS from "crypto-js";
import SecureStorage from "secure-web-storage";

const k = `${process.env.VUE_APP_SITENAME}`

// ** AES **
const option = {
    hash: function hash(data) {
        data = CryptoJS.SHA256(data, k);
        return data.toString();
    },
    encrypt: function encrypt(data) {
        data = CryptoJS.AES.encrypt(data, k);
        data = data.toString();
        return data;
    },
    decrypt: function decrypt(data) {
        data = CryptoJS.AES.decrypt(data, k);
        data = data.toString(CryptoJS.enc.Utf8);
        return data;
    }
};

const ss = new SecureStorage(localStorage, option);

const state = {
    device: '', // web: pc, mob: mobile web, and: android app, ios, ios app
    connect: false,
    langTyCode: "",
    deviceId: "SVCWEB",
    partnerId: "C0000009",
    bridge: null,
    menuTitle: '',
    loading: false,
    isRefreshing: false,
    // 추가된 항목들
    clubType: "EM-EV",
    requireHead: true,
    emartHome: true,
    ntcPopShow: false,
    ntcTitPopShow: false,
    ntcCnfPopShow: false,
    ntcCmpPopShow: false,
    ntcRtnPopShow: false,
    msgTit: '',
    msg: '',
    cmpMsg: '',
    cnfMsg: '',
    rtnMsg: '',
    ntcPopOnClose: null, // 팝업 닫기 후 콜백
    scheduleViewMode: 'month', // 스케줄 뷰 모드 ('month', 'day', 'list')
    logoutCnfPopShow: false,
    camPopShow: false,
    chargerNum: '',
    currentRouteName: '',
    theme: 'system', // 'system', 'light', 'dark'
    fontSize: 'medium', // 'small', 'medium', 'large'
    toastShow: false,
    toastMsg: '',
    toastType: 'success', // success, error, info
    isSidebarCollapsed: false // 사이드바 접힘 상태 전역 관리
}
const mutations = {
    set(state, [variable, value]) {
        state[variable] = value;
    },
}

const actions = {
    showToast({ commit }, { msg, type = 'success', duration = 3000 }) {
        commit('set', ['toastMsg', msg]);
        commit('set', ['toastType', type]);
        commit('set', ['toastShow', true]);

        setTimeout(() => {
            commit('set', ['toastShow', false]);
        }, duration);
    }
}

const store = createStore({
    state,
    mutations,
    actions,
    modules: {
        userStore: userStore,
        commonStore: commonStore
    },
    plugins: [
        createPersistedState({
            key: 'vuex-state',
            storage: ss,
            paths: ['userStore', 'theme', 'fontSize', 'isSidebarCollapsed']
        })
    ]
})
export default store